module.exports = __webpack_public_path__ + "img/dragon.cade4cc0.png";